import type { ReactNode } from "react"
import React from "react"

import type { Loading } from "@/lib/loading"

import { LoadingSpinner } from "@/components/common/LoadingSpinner"

type Props = {
  children: ReactNode
  loading: Loading.ContextData
}

type State = Record<string, never>

export class LoadingScreenComponent extends React.PureComponent<Props, State> {
  public render = () => {
    if (this.props.loading.ready) {
      return this.props.children
    }

    return <LoadingSpinner className={`h-screen`} expanded />
  }
}
